import React from 'react';
import { Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="bg-sage-800 text-cream py-2.5 px-4 text-center sticky top-0 z-50 shadow-sm" data-id="element-436">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs md:text-sm font-medium tracking-wider" data-id="element-437">
        <span className="flex items-center gap-2" data-id="element-438">
          <Zap size={16} className="text-yellow-400 fill-yellow-400" data-id="element-439" />
          OFERTA 80% OFF — TERMINA EN
        </span>
        <CountdownTimer variant="inline" data-id="element-440" />
      </div>
    </div>;
}